<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :fill="fill"
       viewBox="0 0 1280 192.75">
    <path d="m750.55,105.85c133.11,43.02,266.22,86.04,401.66,86.04H0V22.08c28.65-5.89,57.58-10.81,86.44-14.41,187.23-23.32,371.42,9.02,554.41,63.63,36.6,10.92,73.15,22.74,109.7,34.55Z"/>
    <path d="m1280,178.83v13.06h-127.79c13.32,0,26.66-.42,40.03-1.29,29.27-1.91,58.65-6.02,87.76-11.77Z"/>
  </svg>
</template>

<script>
export default {
  name: "WaveSmallerIcon",
  props: {
    fill: {
      type: String,
      default: '#fff'
    },
  }
}
</script>
